import * as React from 'react'
import { styled } from '@mui/material/styles'

const PREFIX = 'ContentWithLogoGrid'

const classes = {
  root: `${PREFIX}-root`
}

const Root = styled('div')(({ theme: { breakpoints, spacing } }) => ({
  [`&.${classes.root}`]: {
    flex: 1,
    display: 'grid',
    gap: spacing(3),
    padding: spacing(3),
    gridTemplateAreas: `
      "title"
      "content"
      `,
    [breakpoints.up('md')]: {
      marginTop: spacing(3),
      marginBottom: spacing(3),
      gridTemplateAreas: `
          "logo title"
          ". content"
        `,
      gridTemplateColumns: '200px 1fr 480px',
      padding: 0
    }
  }
}))

const ContentWithLogoGrid: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <Root className={classes.root}>{children}</Root>
}

export default ContentWithLogoGrid
